// extracted by mini-css-extract-plugin
module.exports = {"pageMain":"IndexLayout__pageMain___29gV6","content":"IndexLayout__content___1o-O9","contentMain":"IndexLayout__contentMain___2RrNV"};